import { render, staticRenderFns } from "./AccountCreated.vue?vue&type=template&id=216ab134&"
import script from "./AccountCreated.vue?vue&type=script&lang=ts&"
export * from "./AccountCreated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports